import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFDroidComponent } from './simple-icons-f-droid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFDroidComponent ],
    exports:      [ SimpleIconsFDroidComponent ],
    bootstrap:    []
})
export class SimpleIconsFDroidModule {}
